import { render, staticRenderFns } from "./SelectedPrivilegeDetail.vue?vue&type=template&id=01bbcfce&scoped=true"
import script from "./SelectedPrivilegeDetail.vue?vue&type=script&lang=js"
export * from "./SelectedPrivilegeDetail.vue?vue&type=script&lang=js"
import style0 from "./SelectedPrivilegeDetail.vue?vue&type=style&index=0&id=01bbcfce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbcfce",
  null
  
)

export default component.exports